import { useMemo, useState } from "react";
import type { IntervieweeWitnessItem } from "../hooks/useIntervieweeIncidentViewModel";

type IntervieweeIncidentWitnessSectionProps = {
  items: IntervieweeWitnessItem[];
};

const HEADING = "Atrocities";

export function IntervieweeIncidentWitnessSection({ items }: IntervieweeIncidentWitnessSectionProps) {
  const [activeFamily, setActiveFamily] = useState<string | null>(null);

  const activeText = useMemo(() => {
    if (items.length === 0) {
      return "No detailed incident records are available for this survivor yet.";
    }

    if (!activeFamily) {
      return "Hover or focus an icon to view incident details.";
    }

    return items.find((item) => item.family === activeFamily)?.sentence
      ?? "Incident details are available for this survivor.";
  }, [activeFamily, items]);

  return (
    <article className="box summary-violations incident-witness fade-in">
      <div className="card-accent" aria-hidden="true" />
      <h3>{HEADING}</h3>
      {items.length > 0 ? (
        <div className="incident-witness__icons" role="list" aria-label={HEADING}>
          {items.map((item) => (
            <button
              key={item.family}
              type="button"
              className="incident-witness-icon-button"
              onMouseEnter={() => setActiveFamily(item.family)}
              onMouseLeave={() => setActiveFamily(null)}
              onFocus={() => setActiveFamily(item.family)}
              onBlur={() => setActiveFamily(null)}
              aria-label={`${item.label}: ${item.count}`}
            >
              <img src={item.iconPath} alt="" loading="lazy" />
              <span className="incident-witness-icon-count" aria-hidden="true">{item.count}</span>
            </button>
          ))}
        </div>
      ) : null}
      <div className="summary-violations__text incident-witness__text" aria-live="polite">
        {activeText}
      </div>
    </article>
  );
}
